import {AnyAction, Reducer} from 'redux'
import {RouterState} from 'redux-first-history'
import {combineReducers} from 'redux-loop'

import {Actions} from '../actions'

import auth, {AuthState} from './auth'
import core, {CoreState} from './core'
import modal, {ModalState} from './modal'
import order, {OrderState} from './order'
import toast, {ToastState} from './toast'

export type State = {
  core: CoreState
  modal: ModalState
  auth: AuthState
  toast: ToastState
  router: RouterState
  order: OrderState
}

const createReducer = (routerReducer: Reducer<RouterState, AnyAction>) =>
  combineReducers<State, Actions>({
    core,
    modal,
    auth,
    toast,
    router: routerReducer,
    order,
  })

export default createReducer
